import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const MODEL_GENERATION_CREATE_RESOURCE = "model-generation" as const;
export const MODEL_GENERATION_CREATE_API_PATH = `/v1/${MODEL_GENERATION_CREATE_RESOURCE}` as const;

export type ModelGenerationCreateBody =
  paths[typeof MODEL_GENERATION_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type ModelGenerationCreateInput = ModelGenerationCreateBody;
export type ModelGenerationCreateResponse =
  paths[typeof MODEL_GENERATION_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useModelGenerationCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ModelGenerationCreateResponse, Error, ModelGenerationCreateInput>({
    mutationFn: async (data: ModelGenerationCreateInput) => {
      const response = await alphartisApiAxios.post<ModelGenerationCreateResponse>(
        MODEL_GENERATION_CREATE_API_PATH,
        data,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MODEL_GENERATION_CREATE_RESOURCE],
      });
    },
  });
};
